import { useEffect, useState } from "react";
import useAuth from "../../../authentication/hooks/useAuth";
import Dashboard from "../../../common/Dashboard";
import { OTS_CONFIG_URL } from "../../../api/api_routing_urls";
import useAxiosPrivate from "../../../authentication/hooks/useAxiosPrivate";
import TableWrapper from "../../../reusable-components/table/TableWrapper";
import { MdPhoneIphone } from "react-icons/md";
import { Paging } from "../../../reusable-components/paging/Paging";
import { getFormattedDateDDMMMYYYYDate } from "../../../utilities/dateFunctions/formatdate";
import SearchField from "../../../reusable-components/search/SearchField";
import H2withIcon from "../../../reusable-components/headings/H2withIcon";
import { IoMdPrint } from "react-icons/io";
import { IconContext } from "react-icons";
import { PrintReport } from "../../system-admin/ReportsList/PrintReport/PrintReport";
import PreOtsNotice from "../../system-admin/ReportsList/PrintReport/PreOtsNotice";
import { formatINRCurrency } from "../../../utilities/currency/currency";
import { FaFilePdf } from "react-icons/fa6";

const PreOtsListing = () => {
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const controller = new AbortController();
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [pageSize, setPageSize] = useState();
  const [printNotice, setPrintNotice] = useState(false);
  const [preOtsDetails, setpreOtsDetails] = useState([]);
  const [selectedReferenceNo, setSelectedReferenceNo] = useState(null);
  const [selectedApplicantFullDetails, setSelectedApplicantFullDetails] =
    useState({});

  const onPageChangeHandler = (page_no, action_type) => {
    if (action_type === "Next") {
      parseInt(page_no) + 1 <= numberOfPages &&
        setPageNo(() => parseInt(page_no) + 1);
    }
    if (action_type === "Prev") {
      parseInt(page_no) - 1 >= 1 && setPageNo(() => parseInt(page_no) - 1);
    }
  };

  const handleGetSelectedPreOtsNotice = async (selected_id) => {
    const filteredData = preOtsDetails?.find(
      (obj) => obj?.loanee_id == selected_id
    );

    if (!filteredData) return;

    // console.log(filteredData);
    const formattedObject = {
      ...filteredData,
      outstanding_amt: filteredData.principal_outstanding,
      interest_due_amount: filteredData.interest_due,
      penal_int_due: filteredData.penal_interest,
      ioi_int_due: filteredData.interest_on_interest,
    };

    setSelectedApplicantFullDetails(formattedObject);
  };

  useEffect(() => {
    (async () => {
      try {
        const payload = {
          pgno: pageNo || 1,
          pgsize: pageSize?.value || 10,
          searchtext: searchText || "",
        };

        const res = await axiosPrivate.post(
          `${OTS_CONFIG_URL}/get/pre-ots-notice-details`,
          payload,
          {
            signal: controller.signal,
          }
        );

        setpreOtsDetails(res?.data?.response?.res?.data || []);

        setNumberOfPages(
          Math.ceil(res?.data?.response?.res?.total / (pageSize?.value || 10))
        );
      } catch (error) {
        console.log("error ", error);
      }
    })();
  }, [searchText, pageNo, pageSize]);

  return (
    <section>
      <Dashboard sidebarType={auth.rolename}>
        <div className="flex justify-between w-full">
          <div onClick={() => setSelectedReferenceNo(null)}>
            <H2withIcon>
              <IconContext.Provider value={{ className: "text-secondary" }}>
                <FaFilePdf />
              </IconContext.Provider>
              <span>&nbsp; Pre OTS Notices</span>
            </H2withIcon>
          </div>
          <div>
            <SearchField
              placeholder="Search"
              defaultValue={searchText}
              onChange={(e) => {
                setSearchText(e);
              }}
              onClick={() => {
                setPageNo(1);
              }}
              classes={"bg-primary"}
            />
          </div>
        </div>

        <TableWrapper>
          {/* <table> */}
          <thead className="bg-white text-xs  md:text-sm ">
            <tr className="bg-slate-200 sticky top-0 z-0">
              <th scope="col" className="px-3 py-2 text-left font-medium">
                SL No.
              </th>
              <th scope="col" className="px-3 py-2 text-left font-medium">
                Loanee ID
              </th>
              <th
                scope="col"
                className="px-3 py-2 text-left font-medium flex flex-col min-w-44"
              >
                <span>Applicant Name</span>{" "}
              </th>
              <th scope="col" className="px-3 py-2 text-left font-medium">
                Contact
              </th>

              <th scope="col" className="px-3 py-2 text-left font-medium">
                Reference No.
              </th>

              <th scope="col" className="px-3 py-2 text-left font-medium">
                Date
              </th>
              <th scope="col" className="px-3 py-2 text-center font-medium">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-slate-100 text-slate-600">
            {preOtsDetails?.length > 0 ? (
              preOtsDetails?.map((data, index) => (
                <tr
                  key={index}
                  className={index % 2 === 1 ? "bg-slate-100" : null}
                >
                  <td className="px-3 py-1.5 text-xs 2xl:text-sm ">
                    <div className="flex">
                      <span>{(pageNo - 1) * (pageSize || 10) + index + 1}</span>
                      <span>
                        {selectedReferenceNo == data?.reference_number ? (
                          <p className="flex flex-col text-left">
                            <span class="relative flex ml-2 pt-[2px]">
                              <span class="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-[#F95B39] opacity-75"></span>
                              <span class="relative inline-flex rounded-full h-2 w-2 text-white bg-[#F95B39] items-center justify-center text-xs font-medium"></span>
                            </span>
                          </p>
                        ) : null}
                      </span>
                    </div>
                  </td>

                  <td className="px-3 py-1.5 text-xs 2xl:text-sm ">
                    <p className="flex flex-col text-left ">
                      <span>{data?.loanee_id}</span>
                    </p>
                  </td>

                  <td className="px-3 py-1.5 text-xs 2xl:text-sm ">
                    <p className="flex flex-col text-left ">
                      <span>{data?.applicantname}</span>

                      <span className="font-semibold text-xs 2xl:text-sm">
                        ({data?.categoryname})
                      </span>
                    </p>
                  </td>

                  <td className="px-3 py-1.5 whitespace-nowrap text-xs md:text-sm ">
                    <span className="flex gap-0.5">
                      <span className="mt-0.5 text-primary">
                        <MdPhoneIphone size={15} />
                      </span>

                      {data?.contactno > 0 ? data?.contactno : "---"}
                    </span>
                  </td>

                  <td className="px-3 py-1.5 whitespace-nowrap text-xs md:text-sm">
                    {data?.reference_number}
                  </td>

                  <td className="px-3 py-1.5 whitespace-nowrap text-xs md:text-sm">
                    {getFormattedDateDDMMMYYYYDate(data?.pre_ots_date)}
                  </td>
                  <td className="px-3 ps-10 py-1.5 whitespace-nowrap text-xs md:text-sm">
                    <IoMdPrint
                      onClick={() => {
                        setSelectedReferenceNo(data?.reference_number);
                        handleGetSelectedPreOtsNotice(data?.loanee_id);
                        setPrintNotice(true);
                      }}
                      size={22}
                      className="cursor-pointer"
                    />
                  </td>
                </tr>
              ))
            ) : (
              <>
                <tr className="m-auto text-center">
                  <td colSpan={9} className="py-3">
                    No List Found
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </TableWrapper>

        <div>
          <Paging
            maxMenuHeight={100}
            selected={pageSize}
            setSelected={setPageSize}
            pageNo={pageNo}
            onPageChangeHandler={onPageChangeHandler}
            numberOfPages={numberOfPages}
          />
        </div>

        {printNotice && (
          <div
            className="fixed inset-0 bg-black/40 z-50"
            onClick={() => {
              setSelectedReferenceNo(null);
              setPrintNotice(false);
            }}
          >
            <div
              className="fixed right-0 top-0 h-full w-[480px] bg-white shadow-2xl p-6 animate-slideLeft"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex justify-between items-center border-b pb-3">
                <div>
                  <h2 className="text-xl font-bold">
                    {selectedApplicantFullDetails?.applicantname || "N/A"}
                  </h2>
                  <p className="text-gray-600">
                    Ref:{" "}
                    {selectedApplicantFullDetails?.reference_number || "N/A"}
                  </p>
                </div>

                <button
                  onClick={() => {
                    setPrintNotice(false);
                    setSelectedReferenceNo(null);
                  }}
                  className="text-gray-500 hover:text-black text-3xl leading-none"
                >
                  &times;
                </button>
              </div>

              {/* Additional Info */}
              <div className="mt-4 bg-gray-50 p-4 rounded-lg border text-sm text-gray-700 space-y-1">
                <div className="flex justify-between">
                  <span className="font-medium">Loanee ID:</span>
                  <span>{selectedApplicantFullDetails?.loanee_id}</span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Loan Number:</span>
                  <span>
                    {selectedApplicantFullDetails?.loan_number_from_loan}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Category:</span>
                  <span>{selectedApplicantFullDetails?.categoryname}</span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Contact:</span>
                  <span>{selectedApplicantFullDetails?.contactno || "-"}</span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Loan Scheme:</span>
                  <span>{selectedApplicantFullDetails?.loan_scheme}</span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Loan Status:</span>
                  <span>{selectedApplicantFullDetails?.loan_status}</span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Applied Amount:</span>
                  <span>
                    {formatINRCurrency(
                      selectedApplicantFullDetails?.loanappliedamt || 0
                    )}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Pre OTS Date:</span>
                  <span>
                    {getFormattedDateDDMMMYYYYDate(
                      selectedApplicantFullDetails?.pre_ots_date
                    )}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium">Repayment Due:</span>
                  <span>
                    {formatINRCurrency(
                      selectedApplicantFullDetails?.repayment_due || 0
                    )}
                  </span>
                </div>
              </div>

              {/* Body */}
              <div className="mt-4 max-h-[63vh] gap-x-3 flex items-center justify-around overflow-y-auto">
                <div>
                  <PrintReport reportTitle="OTS" buttonName="Pre-OTS Notice">
                    <PreOtsNotice
                      otsCalculation={selectedApplicantFullDetails}
                      otsDate={selectedApplicantFullDetails?.pre_ots_date}
                      selectedApplicantDetails={selectedApplicantFullDetails}
                      setSelectedRefrenceNumber={
                        selectedApplicantFullDetails?.reference_number
                      }
                    />
                  </PrintReport>
                </div>

                <div>
                  <button
                    onClick={() => {
                      setPrintNotice(false);
                      setSelectedReferenceNo(null);
                    }}
                    className="w-[10rem] py-2 bg-gray-200 hover:bg-gray-300"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </Dashboard>
    </section>
  );
};

export default PreOtsListing;
